import { useState } from "react";
import { CrossIcon, PlayCircleIcon } from "../Icons";
import CustomModal from "./CustomModal";

export default function DemoBtn() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => setIsModalOpen((prev) => !prev);

  return (
    <div>
      <button
        className="flex items-center gap-2 bg-custom-blue-medium text-white px-5 py-2.5 rounded-xl text-sm shadow-md hover:bg-custom-blue-dark transition-all duration-200 active:scale-[0.97]"
        onClick={toggleModal}
      >
        <PlayCircleIcon className="size-5" />
        <span>Watch Demo</span>
      </button>

      <CustomModal
        open={isModalOpen}
        onClose={toggleModal}
        className="bg-white rounded-2xl shadow-2xl p-6 max-w-4xl w-full relative"
      >
        <button
          onClick={toggleModal}
          className="absolute top-5 right-5 hover:scale-90 transition-transform"
        >
          <CrossIcon className="size-6 text-gray-600 hover:text-red-500" />
        </button>

        <div>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Demo Video
          </h2>

          {/* Responsive video container */}
          <div className="relative w-full overflow-hidden rounded-xl shadow-lg bg-black">
            {/* Maintain 16:9 aspect ratio */}
            <div className="pb-[56.25%]"></div>

            <video
              src="https://taram.io/files/demo_vedio/Deal_Tracker_Demo.mp4"
              controls
              playsInline
              preload="metadata"
              className="absolute inset-0 w-full h-full object-contain rounded-xl bg-black"
            >
              Sorry, your browser doesn’t support embedded videos.
            </video>
          </div>
        </div>
      </CustomModal>
    </div>
  );
}
